// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.indicator-info-panel {
  height: 100%;
  background: var(--card-bg);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  box-shadow: 0 1px 3px var(--shadow);
  padding: 18px;
  overflow-y: auto;
  box-sizing: border-box;
  color: var(--text-primary);
}

.indicator-info-panel hr {
  border-color: var(--border);
}

.indicator-info-nav-trail {
  margin-bottom: 15px;
  padding: 8px;
  background: var(--hover);
  border-radius: var(--radius-sm);
  font-size: 12px;
  color: var(--text-secondary);
}

.indicator-info-toolbar {
  display: flex;
  gap: 8px;
  margin-bottom: 5px;
  align-items: center;
}

.indicator-info-related-btn {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 6px;
}
`, "",{"version":3,"sources":["webpack://./src/components/charts/IndicatorInfoPanel.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;EAC/B,mCAAmC;EACnC,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;EACxB,+BAA+B;EAC/B,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV","sourcesContent":[".indicator-info-panel {\n  height: 100%;\n  background: var(--card-bg);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  box-shadow: 0 1px 3px var(--shadow);\n  padding: 18px;\n  overflow-y: auto;\n  box-sizing: border-box;\n  color: var(--text-primary);\n}\n\n.indicator-info-panel hr {\n  border-color: var(--border);\n}\n\n.indicator-info-nav-trail {\n  margin-bottom: 15px;\n  padding: 8px;\n  background: var(--hover);\n  border-radius: var(--radius-sm);\n  font-size: 12px;\n  color: var(--text-secondary);\n}\n\n.indicator-info-toolbar {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 5px;\n  align-items: center;\n}\n\n.indicator-info-related-btn {\n  margin-left: auto;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
